import {Exchange} from "../../proto/generated/common"
import {GetOptionChainRequestV2, OptionChainProto, OptionExpiriesProto} from "../../proto/generated/candle-data-depot-option-chain";
import { FutureSecurities } from "../../proto/generated/future";
import api from "./axiosClient"
import {Security} from "../../proto/generated/security"
import { GetCurrentOpenInterestRequest, GetCurrentOpenInterestResponse } from "../../proto/generated/candle-data-depot";
// import { GetImpliedVolatilityTimeSeriesRequest, GetImpliedVolatilityTimeSeriesResponse } from "../../proto/generated/candle-data-depot-implied-volatility";


export const getOptionChainV2 = async (data: GetOptionChainRequestV2): Promise<OptionChainProto> => {
    const url = `/v2/options/optionchain`
    try {
        const response = await api.post(url, JSON.stringify(data), {
            headers: { 'Accept': 'application/x-protobuf' },
            responseType: 'arraybuffer'
        })
        return OptionChainProto.decode(new Uint8Array(response.data))
    } catch (error: any) {
        if (error?.isLocal && error?.promise) {
            const response = await error.promise
            return OptionChainProto.decode(new Uint8Array(response.data))
        }
        throw error
    }
}

export const getOptionExpiriesV2 = async (args: { exchange: Exchange, securityCode: string }): Promise<OptionExpiriesProto> => {
    const url = `/v2/options/expiries`
    try {
        const response = await api.get(url, {
            headers: { 'Accept': 'application/x-protobuf' },
            params: {
                exchange: Exchange[args.exchange ?? 1],
                securityCode: args.securityCode
            },
            responseType: 'arraybuffer'
        })
        return OptionExpiriesProto.decode(new Uint8Array(response.data))
    } catch (error: any) {
        if (error?.isLocal && error?.promise) {
            const response = await error.promise
            return OptionExpiriesProto.decode(new Uint8Array(response.data))
        }
        throw error
    }
}

export const getFutures = async (security: Partial<Security> = {}): Promise<FutureSecurities> => {
    try {
        const response = await api.get(`/futures`, {
            headers: { 'Accept': 'application/x-protobuf' },
            params: {
                exchange: Exchange[security.exchange ?? 1],
                securityCode: security.code
            },
            responseType: 'arraybuffer'
        })
        return FutureSecurities.decode(new Uint8Array(response.data))
    } catch (error: any) {
        if (error?.isLocal && error?.promise) {
            const response = await error.promise
            return FutureSecurities.decode(new Uint8Array(response.data))
        }
        throw error
    }
}

export const getOptionPastExpiries = async (args: { exchange: Exchange, securityCode: string }): Promise<OptionExpiriesProto> => {
    return new Promise((resolve, reject) => {
        const url = `/options/dead-expiries`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            params: {
                exchange: Exchange[args.exchange ?? 1],
                securityCode: args.securityCode
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = OptionExpiriesProto.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        });
    })
}

export const getPastExpiries = async (security: Partial<Security> = {}): Promise<FutureSecurities> => {
    try {
        const response = await api.get(`futures/dead-expiries`, {
            headers: { 'Accept': 'application/x-protobuf' },
            params: {
                exchange: Exchange[security.exchange ?? 1],
                securityCode: security.code
            },
            responseType: 'arraybuffer'
        })
        return FutureSecurities.decode(new Uint8Array(response.data))
    } catch (error: any) {
        if (error?.isLocal && error?.promise) {
            const response = await error.promise
            return FutureSecurities.decode(new Uint8Array(response.data))
        }
        throw error
    }
}

export const getCurrentOpenInterests = async (request: GetCurrentOpenInterestRequest): Promise<GetCurrentOpenInterestResponse> => {
    return new Promise((resolve, reject) => {
        const url = `/options/open-interest-current`
        api.post(url, JSON.stringify(request), {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        }).then(async (response) => {
            const decodedData = GetCurrentOpenInterestResponse.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        });
    })
}